import { Talent } from "../../../types/user";
import Container from "./Container";
import "./EditProfile.scss";
import GenralInfoForm from "./GenralInfoForm";
import { useFormik } from "formik";
import ProfessionalInfoForm from "./ProfessionalInfoForm";
import { useUpdateTalent } from "../../../services/api/talent.api";
import { enqueueSnackbar } from "notistack";
import { organizeData } from "../../../components/RegisterTalentForm/OrganizeData";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
interface InputData {
  username: string;
  categories: string;
  bio: string;
  profile_image: string | File;
  cover_image: string | File;
  portfolio_links: string[];
  social_links: string[];
  skills?: string[];
}

const EditForm = ({ talentInfo }: { talentInfo: Talent }) => {
  const navigate = useNavigate();
  const { update } = useUpdateTalent({
    key: ["talent-profile", talentInfo?.id],
    params: {
      id: parseInt(talentInfo?.id),
    },
  });

  const {
    errors,
    handleSubmit,
    handleChange,
    setFieldValue,
    values,
    isSubmitting,
    touched,
  } = useFormik<InputData>({
    initialValues: {
      username: talentInfo?.username || "",
      categories: talentInfo?.categories?.[0] || "",
      bio: talentInfo?.bio || "",
      profile_image: talentInfo?.profile_image || "",
      cover_image: talentInfo?.cover_image || "",
      portfolio_links: talentInfo?.portfolio_links || [""],
      social_links: talentInfo?.social_links || [],
      skills: talentInfo?.skills || [],
    },
    validateOnBlur: false,
    validationSchema: yup.object().shape({
      username: yup
        .string()
        .required("Username is required")
        .min(2, "Username must be at least 2 characters"),
      categories: yup.string().required("Category is required"),
      portfolio_links: yup
        .array()
        .of(yup.string().url("Portfolio link must be a valid URL")),
      social_links: yup.array().of(
        yup.object().shape({
          url: yup.string().url("Social link must be a valid URL"),
        })
      ),
    }),
    onSubmit: async (values) => {
      try {
        const uploadFile = async (file: File): Promise<string> => {
          const formData = new FormData();
          formData.append("file", file);

          const uploadRes = await fetch(
            "https://api.taasnet.com/api/v1/file-upload",
            {
              method: "POST",
              body: formData,
              headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token") || ""}`,
                Accept: "*/*",
              },
            }
          );

          if (!uploadRes.ok) {
            throw new Error("Failed to upload file");
          }

          const uploadJson = await uploadRes.json();
          return uploadJson.data.url;
        };

        let profileImage = values.profile_image;
        let coverImage = values.cover_image;

        if (values.profile_image instanceof File) {
          profileImage = await uploadFile(values.profile_image);
        }

        if (values.cover_image instanceof File) {
          coverImage = await uploadFile(values.cover_image);
        }

        const updatedValues = {
          ...values,
          profile_image: profileImage as string,
          cover_image: coverImage as string,
          portfolio_links: values.portfolio_links.filter(
            (link) => link.trim() !== ""
          ),
          social_links: values.social_links.filter(
            (link: any) => link.url.trim() !== ""
          ) as any,
        };

        await update(organizeData(updatedValues), {
          onSuccess: () => {
            enqueueSnackbar("Profile updated successfully!", {
              variant: "success",
            });
            navigate("/talent/profile");
          },
        });
      } catch (error: any) {
        console.log(error, "error");
        enqueueSnackbar(
          error?.response?.data?.message || "Failed to update profile.",
          { variant: "error" }
        );
      }
    },
  });
  console.log(errors, "errors");
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Container
          title="General Information"
          description="Update your photo and personal details."
        >
          <GenralInfoForm
            values={values}
            handleChange={handleChange}
            errors={errors}
            setFieldValue={setFieldValue}
          />
        </Container>
        <Container
          title="Professional Information"
          description="Update your photo and personal details."
        >
          <ProfessionalInfoForm
            values={values}
            handleChange={handleChange}
            errors={errors}
            setFieldValue={setFieldValue}
            isSubmitting={isSubmitting}
            touched={touched}
          />
        </Container>
      </form>
    </div>
  );
};

export default EditForm;
